/*eslint-disable no-var */
/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import DonutChart from '../../donutchart/DonutChart';
import EnableIntegration from '../../../shared/EnableIntegration';
import MemberSummary from '../../../api/MemberSummary';
import Dependent from '../../../api/Dependent';
import MemberCoverageSummary from '../../../api/MemberCoverageSummary';
import MasterPermissions from '../../../api/MasterPermissions';
import './Coverage.scss';
import { useTranslation } from 'react-i18next';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});

const ShowMore = () => {
  var iIndex = 0;
  const products = [];
  //Accumulators
  let InNetworkRemaining = 0;
  let OOPRemaining = 0;
  let InNetworkPercent = 0;
  let OOPPercent = 0;
  const InNetworkDed = [];
  const DedFamilyAmt = [];
  const InNetworkOOP = [];
  const FamilyOOP = [];

  const { t } = useTranslation();

  const [toggle, setToggle] = useState(false);
  let membercoverageResp = '';
  let memberSeqID;

  const memberAccumDetailsResp = MemberCoverageSummary.getAccoumulatorDetails(
    MemberCoverageSummary.getSelectedItem(),
  );

  console.log('Mobile Inside Showmore');
  EnableIntegration.ToggleAPIIntegration(EnableIntegration.enableIntegration);
  if (EnableIntegration.isAPIIntegrationEnabled()) {
    console.log(
      'Mobile # of dependents: ',
      MemberSummary.getNumberOfDependents(),
    );
    if (MemberSummary.getNumberOfDependents() == 0) {
      MemberCoverageSummary.coverageList.push({
        name:
          MemberSummary.getFirstName() +
          ' (' +
          MemberSummary.getMemberType() +
          ')',
      });
      console.log(
        'Mobile show more Select Item: ',
        MemberCoverageSummary.coverageList[
          MemberCoverageSummary.getSelectedItem()
        ],
      );
    } else {
      //eslint-disable-next-line no-useless-concat
      MemberCoverageSummary.coverageList.push({
        name:
          'FAMILY' + ' (' + (MemberSummary.getNumberOfDependents() + 1) + ')',
      });
      console.log('Mobile show more: ', MemberCoverageSummary.coverageList[0]);

      MemberCoverageSummary.coverageList.push({
        name:
          MemberSummary.getFirstName() +
          ' (' +
          MemberSummary.getMemberType() +
          ')',
      });
      console.log('Mobile show more: ', MemberCoverageSummary.coverageList[1]);
      for (
        iIndex = 0;
        iIndex < MemberSummary.getNumberOfDependents();
        iIndex++
      ) {
        MemberCoverageSummary.coverageList.push({
          name:
            Dependent.getFirstName(iIndex) +
            ' (' +
            Dependent.getRelationshipToMember(iIndex) +
            ')',
        });
        console.log(
          'Mobile show more: ',
          MemberCoverageSummary.coverageList[iIndex],
        );
      }
      console.log(
        'Mobile show more Select Item: ',
        MemberCoverageSummary.coverageList[
          MemberCoverageSummary.getSelectedItem()
        ],
      );
    }
    membercoverageResp = MemberCoverageSummary.getMemberCoverage(
      MemberCoverageSummary.getSelectedItem(),
    );
    console.log('Mobile Showmore membercoverageResp: ', membercoverageResp);

    memberSeqID = MemberCoverageSummary.getSelectedItem();
    if (memberSeqID > 0) memberSeqID = memberSeqID - 1;

    for (
      var iIndex = 0;
      iIndex < MemberCoverageSummary.getPlansEnrolled();
      iIndex++
    ) {
      MemberCoverageSummary.benefitPlan[iIndex] =
        membercoverageResp.Response.EligibilityCoverage[0].MemberCoverage[
          iIndex
        ].BenefitPlan;
      MemberCoverageSummary.coverageType[iIndex] =
        membercoverageResp.Response.EligibilityCoverage[0].MemberCoverage[
          iIndex
        ].CoverageType;
      console.log(
        'Mobile Benefit plan outside: ',
        MemberCoverageSummary.benefitPlan[iIndex],
      );
      if (MemberCoverageSummary.benefitPlan[iIndex] == null) {
        MemberCoverageSummary.coverageType[iIndex] =
          MemberCoverageSummary.coverageType[iIndex] + '-NULL';
      }
      console.log(
        'Mobile Coverage Type and benefit plan: ',
        MemberCoverageSummary.coverageType[iIndex],
      );
    }
    console.log(
      'Mobile show more Select Item: ',
      MemberCoverageSummary.coverageList[
        MemberCoverageSummary.getSelectedItem()
      ],
    );

    iIndex = 0;
    membercoverageResp.Response.EligibilityCoverage.map((data) => {
      data.MemberCoverage.map((coverageInfo) => {
        console.log('coverageInfo: ', coverageInfo);
        products[iIndex] = coverageInfo.CoverageType;
        console.log('products: ', coverageInfo.CoverageType);
        if (coverageInfo.BenefitPlan == null)
          //eslint-disable-next-line no-useless-concat
          MemberCoverageSummary.coverageInfo[iIndex] =
            data.MemberID + '#' + coverageInfo.CoverageType + '#' + 'NULL';
        else
          MemberCoverageSummary.coverageInfo[iIndex] =
            data.MemberID +
            '#' +
            coverageInfo.CoverageType +
            '#' +
            coverageInfo.BenefitPlan;

        console.log(
          'MemberCoverage.coverageInfo: ',
          MemberCoverageSummary.coverageInfo[iIndex],
        );
        iIndex++;
      });
    });
    memberAccumDetailsResp.Response.BenefitAccumulators.map((data) => {
      iIndex = 0;
      for (iIndex = 0; iIndex < products?.length; iIndex++) {
        if (products[iIndex] == data.Product) {
          if (
            MemberSummary.getNumberOfDependents() > 0 &&
            MemberSummary.memberSeqID == 0
          ) {
            InNetworkDed[iIndex] =
              data.Accumulators.PlanYearFamily.InNetworkDeductible;
            InNetworkOOP[iIndex] =
              data.Accumulators.PlanYearFamily.InNetworkOutOfPocket;
          } else {
            InNetworkDed[iIndex] =
              data.Accumulators.PlanYearPatient.InNetworkDeductible;
            InNetworkOOP[iIndex] =
              data.Accumulators.PlanYearPatient.InNetworkOutOfPocket;
          }
        }
      }
    });

    memberAccumDetailsResp.Response.PlanDetails.map((data) => {
      iIndex = 0;
      for (iIndex = 0; iIndex < products?.length; iIndex++) {
        if (products[iIndex] == data.Product) {
          if (
            MemberSummary.getNumberOfDependents() > 0 &&
            MemberSummary.memberSeqID == 0
          ) {
            DedFamilyAmt[iIndex] = data?.Benefits?.DedFamilyAmount;
            FamilyOOP[iIndex] = data?.Benefits?.FamilyOutOfPocketAmount;
          } else {
            DedFamilyAmt[iIndex] = data?.Benefits?.DedIndividualAmount;
            FamilyOOP[iIndex] = data?.Benefits?.IndvOutOfPocketAmount;
          }
        }
      }
    });

    for (iIndex = 0; iIndex < products?.length; iIndex++) {
      //For In Network
      //InNetworkDed[iIndex] = 0; // for no deductible testing purposes
      if (InNetworkDed[iIndex] == 0) {
        InNetworkRemaining = 0;
        InNetworkPercent = 0;
        MemberCoverageSummary.coverageInfo[iIndex] +=
          '#' + InNetworkRemaining + '#' + InNetworkPercent;
      } else {
        InNetworkRemaining = DedFamilyAmt[iIndex] - InNetworkDed[iIndex];
        if (isNaN(InNetworkRemaining)) InNetworkRemaining = 0;

        if (InNetworkRemaining <= 0) {
          InNetworkRemaining = 0;
          InNetworkPercent = 0;
        } else
          InNetworkPercent = Math.floor(
            (InNetworkDed[iIndex] / DedFamilyAmt[iIndex]) * 100,
          );

        if (isNaN(InNetworkPercent)) InNetworkPercent = 0;

        MemberCoverageSummary.coverageInfo[iIndex] +=
          '#' + InNetworkRemaining + '#' + InNetworkPercent;
      }

      //For Out of Pocket
      if (InNetworkOOP[iIndex] == 0) {
        OOPRemaining = 0;
        OOPPercent = 0;

        MemberCoverageSummary.coverageInfo[iIndex] +=
          '#' + OOPRemaining + '#' + OOPPercent;
      } else if (InNetworkOOP[iIndex] == -1) {
        OOPRemaining = -1;
        OOPPercent = -1;

        MemberCoverageSummary.coverageInfo[iIndex] +=
          '#' + OOPRemaining + '#' + OOPPercent;
      } else {
        OOPRemaining = FamilyOOP[iIndex] - InNetworkOOP[iIndex];
        if (isNaN(OOPRemaining)) OOPRemaining = 0;

        console.log('OOPRemaining: ', OOPRemaining);
        if (OOPRemaining <= 0) {
          OOPRemaining = 0;
          OOPPercent = 0;
        } else
          OOPPercent = Math.floor(
            (InNetworkOOP[iIndex] / FamilyOOP[iIndex]) * 100,
          );

        if (isNaN(OOPPercent)) OOPPercent = 0;

        console.log('OOPPercent: ', OOPPercent);
        MemberCoverageSummary.coverageInfo[iIndex] +=
          '#' + OOPRemaining + '#' + OOPPercent;
      }

      console.log(
        'Calculated OOP: ',
        MemberCoverageSummary.coverageInfo[iIndex],
      );
    }
  } else {
    MemberCoverageSummary.coverageList.push(
      { name: 'FAMILY (16)' },
      { name: 'Dennis (Member) ' },
      { name: 'Jane (Spouse) ' },
      { name: 'Kaylee (Dependent)  ' },
      { name: 'Edward (Dependent) ' },
      { name: 'Emily (Dependent)  ' },
      { name: 'Josh (Dependent)' },
    );

    MemberCoverageSummary.coverageInfo = [
      'b4ef2c8c-9d6f-4233-82c6-59d39b4999a7#Dental#Choice Select PPO#4000#20#8650#13',
      'b4ef2c8c-9d6f-4233-82c6-59d39b4999a7#Vision#Choice Select PPO#6500#13#18400#8',
      'b4ef2c8c-9d6f-4233-82c6-59d39b4999a7#Medical#Choice Select PPO#3350#33#7800#22',
      'b4ef2c8c-9d6f-4233-82c6-59d39b4999a7#Prescription#NULL#0#0',
    ];

    console.log(
      'show more Select Item: ',
      MemberCoverageSummary.coverageList[
        MemberCoverageSummary.getSelectedItem()
      ],
    );
  }

  function renderItems(list) {
    MemberCoverageSummary.listLen = list.length;
    console.log('show more Prev Name: ', MemberCoverageSummary.prevName);
    console.log(
      'show more Selected Name: ',
      MemberCoverageSummary.coverageList[
        MemberCoverageSummary.getSelectedItem()
      ],
    );
    if (
      MemberCoverageSummary.prevName !=
      MemberCoverageSummary.coverageList[
        MemberCoverageSummary.getSelectedItem()
      ]
    ) {
      console.log('show more Prev Name: ', MemberCoverageSummary.prevName);
      MemberCoverageSummary.prevName =
        MemberCoverageSummary.coverageList[
          MemberCoverageSummary.getSelectedItem()
        ];
      MemberCoverageSummary.listShow = 0;
      console.log('show more Selected Name: ', MemberCoverageSummary.prevName);
    }
    if (list && MemberCoverageSummary.listLen > 0) {
      if (MemberCoverageSummary.dispList == 'Show Less') {
        MemberCoverageSummary.dispList = 'Show More';
        MemberCoverageSummary.listShow = 0;
        MemberCoverageSummary.listShow = MemberCoverageSummary.listShow + 1;
        return renderList(
          list.slice(0, MemberCoverageSummary.listShow),
          MemberCoverageSummary.dispList,
        );
      } else if (MemberCoverageSummary.listLen <= 1) {
        return renderList(list, '', false);
      } else if (MemberCoverageSummary.listLen > 1 && toggle === false) {
        MemberCoverageSummary.listShow = MemberCoverageSummary.listShow + 1;
        if (MemberCoverageSummary.listShow >= MemberCoverageSummary.listLen) {
          MemberCoverageSummary.listShow = MemberCoverageSummary.listLen;
          MemberCoverageSummary.dispList = 'Show Less';
        }
        console.log('ListShow - ', MemberCoverageSummary.listShow);
        return renderList(
          list.slice(0, MemberCoverageSummary.listShow),
          MemberCoverageSummary.dispList,
        );
      } else if (MemberCoverageSummary.listLen > 1 && toggle === true) {
        MemberCoverageSummary.listShow = MemberCoverageSummary.listShow + 1;
        if (MemberCoverageSummary.listShow >= MemberCoverageSummary.listLen) {
          MemberCoverageSummary.listShow = MemberCoverageSummary.listLen;
          MemberCoverageSummary.dispList = 'Show Less';
        }
        console.log('ListShow ###- ', MemberCoverageSummary.listShow);
        return renderList(
          list.slice(0, MemberCoverageSummary.listShow),
          MemberCoverageSummary.dispList,
        );
      }
    } else {
      return <p>No Items Found</p>;
    }
  }

  function renderList(list, buttonText, showButton = true) {
    return (
      <div>
        <ul className="mar-padd">
          {list.map((item) => {
            console.log('Mobile MemberCoverageSummary Item', item);
            MemberCoverageSummary.coverageListItem = item.split('#');
            console.log(
              'Mobile MemberCoverageSummary.coverageListItem',
              MemberCoverageSummary.coverageListItem,
            );
            return (
              <div
                className="d-md-none d-xs-block d-sm-block bg-color-carousel-item"
                key={MemberCoverageSummary.coverageListItem[1]}
              >
                {MasterPermissions.CheckPermission(
                  'View Deductible and Out of Pocket',
                ) &&
                  (MemberCoverageSummary.coverageListItem[2] == 'NULL' ? (
                    <div>
                      <Row className="mx-0">
                        <Col className="text-center slider-last-xs" xs={12}>
                          <p>
                            You do not have{' '}
                            {MemberCoverageSummary.coverageListItem[1]}{' '}
                            Coverage. Do you want to explore optoins?
                          </p>
                          <h4>
                            {t('member.dashboard.coverage.coverage_options')}
                          </h4>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    <div className="carousel-chart-coverage">
                      <Row className="mx-0">
                        {MemberCoverageSummary.coverageListItem[4] === '0' ? (
                          <Col className="col-xs-6 min-w38 text-center my-auto">
                            <p id="no-deductible-small">
                              {t('member.dashboard.coverage.this_plan')}
                            </p>
                            <p id="no-deductible">
                              {t('member.dashboard.coverage.no_deductible')}
                            </p>
                          </Col>
                        ) : (
                          <Col className="col-xs-6 min-w38">
                            <DonutChart
                              seriesRadial={[
                                MemberCoverageSummary.coverageListItem[4],
                              ]}
                              chartType="radialBar"
                              chartWidth="90"
                            ></DonutChart>
                            <p className="slide-name">
                              {t('member.dashboard.coverage.deductible')}
                            </p>
                            <h4 className="slide-balance">
                              {formatter.format(
                                MemberCoverageSummary.coverageListItem[3],
                              )}
                            </h4>
                          </Col>
                        )}
                        {MemberCoverageSummary.coverageListItem[5] === '-1' ? (
                          <Col className="col-xs-6 min-w38 text-center my-auto">
                            <p id="unlimited-oop-small">
                              {t('member.dashboard.coverage.this_plan')}
                            </p>
                            <p id="unlimited-oop-middle">
                              {t('member.dashboard.coverage.unlimited')}
                            </p>
                            <p id="unlimited-oop-bottom">
                              {t('member.dashboard.coverage.out_of_pocket')}
                            </p>
                          </Col>
                        ) : (
                          <Col className="col-xs-6 min-w38">
                            <DonutChart
                              seriesRadial={[
                                MemberCoverageSummary.coverageListItem[6],
                              ]}
                              chartType="radialBar"
                              chartWidth="90"
                            ></DonutChart>
                            <p className="slide-name">
                              {t('member.dashboard.coverage.out_of_pocket')}
                            </p>
                            <h4 className="slide-balance">
                              {formatter.format(
                                MemberCoverageSummary.coverageListItem[5],
                              )}
                            </h4>
                          </Col>
                        )}
                      </Row>
                    </div>
                  ))}
                {MemberCoverageSummary.coverageListItem[2] !== 'NULL' ? (
                  <Row className="mx-0">
                    <Col className="slider-details">
                      <h3>{MemberCoverageSummary.coverageListItem[1]} </h3>
                      <p>
                        {t('member.dashboard.coverage.plan')}{' '}
                        <span>{MemberCoverageSummary.coverageListItem[2]}</span>
                      </p>
                      {MasterPermissions.CheckPermission(
                        'View Coverage Details',
                      ) && (
                        <p className="coverage-view-details">
                          <Link to={MemberCoverageSummary.coverageListItem[1]}>
                            {t(
                              'member.dashboard.coverage.view_coverage_details',
                            )}
                          </Link>
                        </p>
                      )}
                    </Col>
                  </Row>
                ) : (
                  <Row className="mx-0">
                    <Col className="slider-details">
                      <h3>{MemberCoverageSummary.coverageListItem[1]} </h3>
                      <p>
                        You do not have{' '}
                        {MemberCoverageSummary.coverageListItem[1]} Coverage.
                      </p>
                      <p className="coverage-view-details">
                        <Link to={'#'}>
                          {t('member.dashboard.coverage.find_coverage_options')}
                        </Link>
                      </p>
                    </Col>
                  </Row>
                )}
              </div>
            );
          })}
        </ul>
        {showButton && (
          <div className="text-center">
            <button onClick={toggleHandler} className="showmore-btn">
              {buttonText}
            </button>
          </div>
        )}
      </div>
    );
  }

  const toggleHandler = () => {
    setToggle((prev) => !prev);
  };

  return (
    <div>
      <div>{renderItems(MemberCoverageSummary.coverageInfo)}</div>
    </div>
  );
};

export default ShowMore;
